import { lruMemoize } from 'reselect';

import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

import { getKeyframesAndPosters } from './get_keyframes_and_posters';

export const findBestKeyframe = lruMemoize(
  (
    keyframesSource: FilesKeyframeSchemaWithIdNullable[] | undefined,
    allowGrowing = false,
  ): FilesKeyframeSchemaWithIdNullable | undefined => {
    const activeKeyframes = getKeyframesAndPosters(
      keyframesSource ?? [],
      allowGrowing,
    );

    const [firstKeyframe, ...restKeyframes] = activeKeyframes;
    let bestKeyframe = firstKeyframe;
    for (const keyframe of restKeyframes) {
      const { height: initHeight = 0, width: initWidth = 0 } =
        bestKeyframe?.resolution || {};
      const { height: currentHeight = 0, width: currentWidth = 0 } =
        keyframe?.resolution || {};

      // Compare pixel area: requiring both dimensions to grow makes the winner
      // depend on array order once aspect ratios differ.
      if (currentWidth * currentHeight > initWidth * initHeight) {
        bestKeyframe = keyframe;
      }
    }
    return bestKeyframe;
  },
);
